import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=13658d70&"
import script from "./TopBanner.vue?vue&type=script&lang=js&"
export * from "./TopBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports